import { DispoEmploymentTabIdEnum } from '../../models/DispoEmploymentTabId.enum';
import { Employment, EmploymentStatusEnum } from '../../models/employment';
import { EmploymentInviteeStatusEnum } from '../../models/employmentInviteeStatusEnum';
import { TransferStatusEnum } from '../../models/transferStatusEnum.enum';
import { DispoUser } from '../../models/user';

export function getDispoTabQuery(
  tabId: DispoEmploymentTabIdEnum,
  user: DispoUser,
  showCanceled: boolean = true,
): Mongo.Selector<Employment> {
  switch (tabId) {
    case DispoEmploymentTabIdEnum.OPEN:
      return { status: EmploymentStatusEnum.OPEN };
    case DispoEmploymentTabIdEnum.BOOKED:
      return {
        $or: [
          {
            status: EmploymentStatusEnum.CLOSED,
            'customer.id': user.customerId,
          },
          {
            status: EmploymentStatusEnum.CLOSED,

            ownerCustomerIds: user.customerId,
          },
          {
            status: EmploymentStatusEnum.CLOSED,
            invitees: {
              $elemMatch: {
                'customer.id': user.customerId,
                status: EmploymentInviteeStatusEnum.BOOKED,
              },
            },
          },
        ],
      };
    case DispoEmploymentTabIdEnum.ARCHIVED:
      return {
        $or: [
          {
            status: showCanceled
              ? {
                  $in: [
                    EmploymentStatusEnum.ARCHIVED,
                    EmploymentStatusEnum.CANCELED,
                  ],
                }
              : EmploymentStatusEnum.ARCHIVED,
          },
          {
            transfers: {
              $elemMatch: {
                'targetCustomer.id': user.customerId,
                transferredAt: { $exists: true },
                status: TransferStatusEnum.ARCHIVED,
              },
            },
          },
          {
            status: EmploymentStatusEnum.CLOSED,
            $and: [
              {
                invitees: {
                  $elemMatch: {
                    'customer.id': user.customerId,
                  },
                },
              },
              {
                invitees: {
                  $not: {
                    $elemMatch: {
                      'customer.id': user.customerId,
                      status: EmploymentInviteeStatusEnum.BOOKED,
                    },
                  },
                },
              },
            ],
          },
        ],
      };
  }
}
